import { Box, Typography, Paper, Grid } from '@mui/material'
import { useAuth } from '../../auth/AuthContext'

export default function PerfilPage() {
  const { auth } = useAuth()
  const rows = [
    ['Usuario', auth?.username],
    ['Sucursal', auth?.locacion?.sucursal?.nombre],
    ['Unidad de negocio', auth?.locacion?.unidadNegocio?.nombre],
    ['Permisos', (auth?.permissions || []).length + ' asignados'],
  ]
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} gutterBottom>Perfil / Empresa</Typography>
      <Paper variant="outlined" sx={{ p: 3, mt: 2, maxWidth: 560 }}>
        <Grid container spacing={2}>
          {rows.map(([k, v]) => (
            <Grid item xs={12} sm={6} key={k}>
              <Typography variant="caption" color="text.secondary">{k}</Typography>
              <Typography variant="body1">{v || '—'}</Typography>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  )
}
